import TooltipCommon from 'components/common/TooltipCommon';
import TooltipCommonMobile from 'components/common/TooltipCommon/mobile';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { Fade } from 'helpers/animation';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import {
  displayFlexRowCenterStartMixin,
  paragraph500Mixin,
  textBreakLineWordMixin,
} from 'styles';
import withInputFieldFocus from '../withInputFieldFocus';

const FormInputValidation = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
  styles,
  inputStyles,
  labelStyles,
  isDisplayOnly,
}) => {
  const { t } = useLang();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();

  const getMessageValidation = (validation) => {
    return t(validation[field.name]);
  };

  const handleFormLabelOnClick = (e) => {
    e.preventDefault();

    if (isDesktop) {
      const inputEle = document.getElementsByName(field.name)[0];

      if (inputEle) {
        inputEle.focus();
      }
    }
  };

  const handleOnChange = () => {};

  const handleOnBlur = () => {};

  if (isDisplayOnly)
    return (
      <FormGroupStyled style={styles}>
        <FormLabel onClick={handleFormLabelOnClick} style={labelStyles}>
          {t(field.label)}
          {field.isRequired && <span>*</span>}
          {field.tooltip && (
            <>
              {isMobile || isTablet ? (
                <TooltipCommonMobile
                  text={t(field.tooltip)}
                  name={field.name}
                  label={t(field.label)}
                />
              ) : (
                <TooltipCommon text={t(field.tooltip)} />
              )}
            </>
          )}
        </FormLabel>
        <FormControlDisplay
          name={field.name}
          placeholder={t(field.placeholder)}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          isInvalid={validation[field.name]}
          readOnly={field.isReadOnly}
          style={inputStyles}
        >
          {information[field.name] || ''}
        </FormControlDisplay>
      </FormGroupStyled>
    );
  return (
    <FormGroupStyled style={styles}>
      <FormLabel onClick={handleFormLabelOnClick} style={labelStyles}>
        {t(field.label)}
        {field.isRequired && <span>*</span>}
        {field.tooltip && (
          <>
            {isMobile || isTablet ? (
              <TooltipCommonMobile
                text={t(field.tooltip)}
                name={field.name}
                label={t(field.label)}
              />
            ) : (
              <TooltipCommon text={t(field.tooltip)} />
            )}
          </>
        )}
      </FormLabel>
      <FormControl
        type={field.type}
        name={field.name}
        defaultValue={information[field.name] || ''}
        placeholder={t(field.placeholder)}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        isInvalid={validation[field.name]}
        readOnly={field.isReadOnly}
        style={inputStyles}
      />
      <FormControlFeedback hidden={false} type="invalid">
        {getMessageValidation(validation)}
      </FormControlFeedback>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: left;

  display: block;
  color: var(--ds-c-grey-dark);

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const FormControl = styled(withInputFieldFocus(Form.Control))`
  ${paragraph500Mixin};
  text-transform: uppercase;
  min-height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-inline: 10px;
  background: var(--ds-c-white);
  ${textBreakLineWordMixin};

  &:focus {
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none !important;
    box-shadow: none !important;
    background-image: none !important;
    padding-inline: 10px !important;
  }

  &[readonly] {
    background: #ececf0;
    border: none;
    color: var(--ds-c-grey-neutral);
    cursor: not-allowed;
  }

  &::placeholder {
    ${paragraph500Mixin};
    text-transform: none;
    color: var(--ds-c-blue-disabled) !important;
  }
`;
const FormControlFeedback = styled(Form.Control.Feedback)`
  ${paragraph500Mixin};
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const FormControlDisplay = styled.div`
  ${paragraph500Mixin};
  text-transform: uppercase;
  min-height: 44px;
  border-radius: 12px;
  padding-inline: 10px;
  background: var(--ds-c-white);
  ${textBreakLineWordMixin};
  ${displayFlexRowCenterStartMixin};

  &[readonly] {
    background: #ececf0;
    border: 1px solid var(--ds-c-blue-remox-light);
    color: var(--ds-c-grey-neutral);
    cursor: not-allowed;
  }

  &:active {
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

export default FormInputValidation;
